import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import createLayout from 'apps/new-web/views/pages/create-layout';
import reducers from './reducers';
import MarketingNav from 'apps/new-web/views/components/header';
import FusionHeroComponent from './components/fusion-hero';
import BenefitsComponent from './components/benefits';
import FooterSignIn from './components/fusion-sign-in';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';

export class PureFusionPage extends BaseComponent {
  static get propTypes() {
    return {
      isPreLogin: PropTypes.Boolean,
      registerUrl: PropTypes.string.isRequired,
      loginUrl: PropTypes.string.isRequired
    };
  }

  constructor(props) {
    super(props);
  }

  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Get epic workouts that are personalized for you! Top trainers teach you how to use your [fusion]. Access quicker, more effective, full-body workouts! Download the [ifit-fusion] app onto your tablet, then sync it up via [bluetooth] technology to get started!', { 'fusion': 'NordicTrack Fusion', 'ifit-fusion': 'iFIT Fusion', 'bluetooth': 'Bluetooth® Smart' }) }" />`;
  }

  render() {
    const { mediaType } = this.props.layout;
    return (
      <div className="fusion-page-component">
        <MarketingNav mediaType={ mediaType } />
        <main id="main-content">
          <FusionHeroComponent loginUrl={ this.props.loginUrl } registerUrl={ this.props.registerUrl } />
          <BenefitsComponent mediaType={ this.props.layout.mediaType } />
          <FooterSignIn loginUrl={ this.props.loginUrl } registerUrl={ this.props.registerUrl } />
        </main>
      </div>
    );
  }
}

const FusionPage = connect(
  (state) => {
    return {
      ...state,
      layout: state.layout
    };
  }
)(PureFusionPage);

export default createLayout(FusionPage, reducers);
